/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Token64LengthType } from '../../models/token-64-length-type';
import { TourGateData } from '../../models/tour-gate-data';

export interface ExternalGetTourGateData$Params {
  token: Token64LengthType;
}

export function externalGetTourGateData(http: HttpClient, rootUrl: string, params: ExternalGetTourGateData$Params, context?: HttpContext): Observable<StrictHttpResponse<TourGateData>> {
  const rb = new RequestBuilder(rootUrl, externalGetTourGateData.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourGateData>;
    })
  );
}

externalGetTourGateData.PATH = '/external/tour/gate';
